module.exports = require('./lib/KeyCode.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/keycode-js/index.js
// module id = 56
// module chunks = 0